import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { HomePage } from "./../home/home";
import { ServiceProvider } from "./../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { TranslateService } from "@ngx-translate/core";
import { ViewHeader2Page } from "./../view-header2/view-header2";
import { Storage } from "@ionic/storage";
import { QuizTestPage } from "./../quiz-test/quiz-test";
import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";
import { VideoTutorialModalPage } from "../video-tutorial-modal/video-tutorial-modal";
// import {
//   StreamingMedia,
//   StreamingVideoOptions,
// } from "@ionic-native/streaming-media";

@IonicPage()
@Component({
  selector: "page-quiz",
  templateUrl: "quiz.html",
})
export class QuizPage {
  interval: any;
  // statusBtn: any = "disabled";
  round: any;
  lang: any;
  role: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("language").then((lang) => {
      this.storage.get("quizRound").then((round) => {
        this.storage.get("info").then((info) => {
          this.round = round;
          this.lang = lang;
          if (info.role == 1) {
            this.role = "plaza";
          } else if (info.role == 2) {
            this.role = "merchant";
          } else {
            this.role = "shopper";
          }
        });
      });
    });
  }

  next() {
    this.navCtrl.setRoot(QuizTestPage, {}, { animate: false });
  }

  doRefresh(refresher) {
    var link = this.services.URLCheckStep;

    this.storage.get("token").then((token) => {
      this.storage.get("info").then((info) => {
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              if (data.step >= 3) {
                this.storage.remove("quizRound");
                this.storage.remove("quizResult");
                this.storage.remove("quiz");
                this.storage.set("stepGame", "home");

                if (info.role == 1) {
                  this.navCtrl.setRoot(HomePage);
                } else if (info.role == 2) {
                  this.navCtrl.setRoot(MerchantHomePage);
                } else if (info.role == 3) {
                  this.navCtrl.setRoot(ShopperHomePage);
                }
              }
            },
            (error) => {
              var response = JSON.parse(error._body);

              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );
      });
    });

    refresher.complete();
  }

  showVideo() {
    // let options: StreamingVideoOptions = {
    //   successCallback: () => {
    //     console.log("Video played");
    //   },
    //   errorCallback: (e) => {
    //     console.log("Error streaming");
    //   },
    //   orientation: "landscape",
    //   shouldAutoClose: true,
    //   controls: true,
    // };
    console.log("lang===>", this.lang);
    console.log("role===>", this.role);
    console.log("round===>", this.round);

    if (this.lang == "en-Us" && this.role == "plaza" && this.role == 1) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 0,
          vdo: video[0].video_url,
        });
        // this.streamingMedia.playVideo(video[0].video_url, options);
      });
    } else if (
      this.lang == "th-TH" &&
      this.role == "plaza" &&
      this.round == 1
    ) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 1,
          vdo: video[1].video_url,
        });
        // this.streamingMedia.playVideo(video[1].video_url, options);
      });
    } else if (
      this.lang == "en-Us" &&
      this.role == "merchant" &&
      this.round == 1
    ) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 2,
          vdo: video[2].video_url,
        });
        // this.streamingMedia.playVideo(video[2].video_url, options);
      });
    } else if (
      this.lang == "th-TH" &&
      this.role == "merchant" &&
      this.round == 1
    ) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 3,
          vdo: video[3].video_url,
        });
        // this.streamingMedia.playVideo(video[3].video_url, options);
      });
    } else if (
      this.lang == "en-Us" &&
      this.role == "shopper" &&
      this.round == 1
    ) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 4,
          vdo: video[4].video_url,
        });
        // this.streamingMedia.playVideo(video[4].video_url, options);
      });
    } else if (
      this.lang == "th-TH" &&
      this.role == "shopper" &&
      this.round == 1
    ) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 5,
          vdo: video[5].video_url,
        });
        // this.streamingMedia.playVideo(video[5].video_url, options);
      });
    } else if (
      this.lang == "en-Us" &&
      this.role == "plaza" &&
      this.round == 2
    ) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 6,
          vdo: video[6].video_url,
        });
        // this.streamingMedia.playVideo(video[6].video_url, options);
      });
    } else if (
      this.lang == "th-TH" &&
      this.role == "plaza" &&
      this.round == 2
    ) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 7,
          vdo: video[7].video_url,
        });
        // this.streamingMedia.playVideo(video[7].video_url, options);
      });
    } else if (
      this.lang == "en-Us" &&
      this.role == "merchant" &&
      this.round == 2
    ) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 8,
          vdo: video[8].video_url,
        });
        // this.streamingMedia.playVideo(video[8].video_url, options);
      });
    } else if (
      this.lang == "th-TH" &&
      this.role == "merchant" &&
      this.round == 2
    ) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 9,
          vdo: video[9].video_url,
        });
        // this.streamingMedia.playVideo(video[9].video_url, options);
      });
    } else if (
      this.lang == "en-Us" &&
      this.role == "shopper" &&
      this.round == 2
    ) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 10,
          vdo: video[10].video_url,
        });
        // this.streamingMedia.playVideo(video[10].video_url, options);
      });
    } else if (
      this.lang == "th-TH" &&
      this.role == "shopper" &&
      this.round == 2
    ) {
      this.storage.get("video").then((video) => {
        this.navCtrl.push(VideoTutorialModalPage, {
          id: 11,
          vdo: video[11].video_url,
        });
        // this.streamingMedia.playVideo(video[11].video_url, options);
      });
    }
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeader2Page);
  }
}



// WEBPACK FOOTER //
// ./src/pages/quiz/quiz.ts